<template>
  <div class="flex flex-1">
    <MediaUpload
      :folder="folder"
      :parent="parent"
      :parent-id="parentId"
      :multiple="multiple"
    />
  </div>
</template>
<script setup>
import MediaUpload from './MediaUpload.vue'

import { useMediaStore } from '@/pinia/MediaStore'
import { storeToRefs } from 'pinia'
import { useProp } from '@/composables/useProp.js'

import { computed, onMounted, ref, toRefs, watch } from 'vue'

const mediaStore = useMediaStore()
const { mediaFiles, isLoading, newMediaFiles, currentItem } = storeToRefs(mediaStore)

const props = defineProps({
  folder: useProp(String),
  parent: useProp(String),
  parentId: useProp(Number),
  multiple: useProp(Boolean, false)
})

const { folder } = toRefs(props)

const folderParts = computed(() => folder.value.split('/'))
onMounted(async () => {
  mediaStore.setCurrentItem(0)
  await mediaStore.load(...folderParts.value)
})


const onItemSelect = (id) => {
  mediaStore.setCurrentItem(id)

  if (!props.multiple) {
    mediaStore.updateSelectedItems(id)
  }
}

</script>
